import { URLSearch2Params, isEmpty, prefixUrl, cookie } from '@/utils'
import { isSystemImplant, system } from '@/utils/system-implant'
import qs from 'qs'
import { useStore } from '@/store'

// tokenKeys 为 token 参数的 key 值
export const tokenKeys = ['u', 'ti', 'tic', 'ticket', 't']
/**
 *
 * @returns {{restParams: {}, tokenParams: {}}}
 */
function getParams() {
  // 获取 url 参数
  const search = URLSearch2Params()

  // restParams 为非 token 参数
  const restParams = {}
  // tokenParams 为 token 参数
  const tokenParams = {}
  Object.keys(search).forEach(key => {
    if (tokenKeys.indexOf(key) >= 0) {
      tokenParams[key] = search[key]
    } else {
      restParams[key] = search[key]
    }
  })
  return { restParams, tokenParams }
}

/**
 * 初始化登录
 * @returns {string}
 */
export function initLogin() {
  const params = getParams()
  const { tokenParams = {}, restParams = {} } = params
  if (!isEmpty(tokenParams)) {
    if (setAuthParams(tokenParams)) {
      const { hash, pathname } = window.location
      return `${pathname}${isEmpty(restParams) ? '' : '?' + qs.stringify(restParams)}${hash}`
    }
    return ''
  }
  return ''
}

export function setAuthParams(tokenParams) {
  const originParams = JSON.parse(cookie.getItem('AUTH_PARAMS') || '{}')
  tokenParams = Object.assign({}, originParams, tokenParams)
  return cookie.setItem('AUTH_PARAMS', JSON.stringify(tokenParams), 7)
}
/**
 *
 * @param data
 */
export function login(data) {
  cookie.removeItem('AUTH_PARAMS')
  const { tokenParams } = getParams()
  cookie.setItem('AUTH_PARAMS', JSON.stringify(tokenParams), 7)
  window.location = data.redirectUrl
}

/**
 *  获取登录参数以及回调地址
 * @returns {{referer: string, ticket: (string|*)}}
 */
export function getAuthParams() {
  let params = JSON.parse(cookie.getItem('AUTH_PARAMS') || '{}')
  if (isEmpty(params)) {
    params = getParams().tokenParams
  }
  // iframe系统嵌入safari不支持设置cookie，ticket从变量中获取
  return {
    ticket: params.ticket || (isSystemImplant() ? system.MISP_SUB_TICKET : params.ticket),
    referer: window.location.href, // dilu 登陆回调地址};
  }
}

/**
 * 登出
 *  1. 清除 cookie，清除 store
 *  2. 跳转到后端登出接口
 */
export function logout() {
  const store = useStore()
  store.loginOut()
  window.location = prefixUrl('common.logout', {}, { isAddCommonParams: true })
}
